var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.$isMobile)?_c('div',{staticClass:"cl border-bottom",staticStyle:{"line-height":"50px","height":"50px"}},[_c('div',{staticClass:"z green f18"},[_vm._v(_vm._s(_vm.$route.meta))]),_c('div',{staticClass:"y",class:_vm.rightClass},[_vm._t("headRight")],2)]):_vm._e(),_c('div',{staticClass:"margin-top"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }